import type { AtvModel } from '../hooks/useAtvModels';

export interface VehiclePresentation {
  key: string;
  name: string;
  image: string;
  imageWidth: number;
  imageHeight: number;
  imagePosition: string;
  specificationTag?: string;
  specificationUrls: { pl: string; en: string; de: string };
}

export const CATALOG_MODELS: readonly VehiclePresentation[] = [
  {
    key: 'odes650',
    name: 'ODES Pathcross 650 Max Pro',
    image: '/images/wypozyczalnia-quadow-szczecin-quadtrip-odes-1.webp',
    imageWidth: 2869,
    imageHeight: 3966,
    imagePosition: 'center 80%',
    specificationTag: 'odes650',
    specificationUrls: {
      pl: 'https://aodeseurope.com/produkty/odes-pathcross-650-max-pro/',
      en: 'https://aodeseurope.com/produkty/odes-pathcross-650-max-pro/',
      de: 'https://aodeseurope.com/produkty/odes-pathcross-650-max-pro/',
    },
  },
  {
    key: 'qjmotor-sfa600',
    name: 'QJMOTOR SFA 600 PRO',
    image: '/images/wypozyczalnia-quadow-szczecin-quadtrip-qjmotor-sfa.webp',
    imageWidth: 4055,
    imageHeight: 4137,
    imagePosition: 'center 60%',
    specificationUrls: {
      pl: 'https://qjmotor.com.pl/sfa-600/',
      en: 'https://global.qjmotor.com/car.html?id=143',
      de: 'https://global.qjmotor.com/car.html?id=143',
    },
  },
];

export function getVehiclePresentation(vehicle: Pick<AtvModel, 'name' | 'tag'>): VehiclePresentation | null {
  const name = vehicle.name.toLowerCase();
  const compactName = name.replace(/[^a-z0-9]/g, '');
  if (compactName.includes('qjmotor') && /sfa[^a-z0-9]*600(?![0-9])/.test(name)) return CATALOG_MODELS[1];
  if (vehicle.tag === 'odes650' || (compactName.includes('odes') && /(?:^|[^0-9])650(?![0-9])/.test(name))) return CATALOG_MODELS[0];
  return null;
}

export function getVehicleSpecificationTag(vehicle: Pick<AtvModel, 'name' | 'tag'>): string | undefined {
  const presentation = getVehiclePresentation(vehicle);
  if (presentation) return presentation.specificationTag;
  if (vehicle.tag === 'benda550' && vehicle.name.toLowerCase().includes('benda')) return 'benda550';
  return undefined;
}
